import {ChevronLeftIcon} from "@heroicons/react/20/solid";
import {Outlet, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useGuideFlowProviderContext} from "../../../GuideFlowProviderContext";
import AddNewJournalEntryView from "./AddNewJournalEntryView";
import ImageCaptureDialog from "../../controls/vidence/image/ImageCaptureDialog";
import {JournalEntryAvatar} from "./JournalEntryAvatar";
import {Image64Data} from "../../../providers/core/storage/HomebaseStorageTypes";
import {Tab} from "../controls/Tab";
import {QueueListIcon} from "@heroicons/react/24/outline";
import {SECTION_ROOT} from "./FormTypes";
import {JournalEntry} from "../../../providers/journal/JournalProvider";
import {truncateText} from "../../viewUtils";

export default function JournalEntryOverview() {
    const navigate = useNavigate();
    const {id} = useParams();

    const context = useGuideFlowProviderContext();
    const [showImageCapture, setShowImageCapture] = useState(false);
    const [journalEntry, setJournalEntry] = useState<JournalEntry | undefined>();

    useEffect(() => {
        if (id !== "new") {
            context.Journal.get(id).then(setJournalEntry);
        }
    }, [context.Journal, context.Journal.StateChanged, id]);

    const backToList = () => {
        navigate(SECTION_ROOT);
    };

    const handleUpdateProfileImage = () => {
        setShowImageCapture(true);
    }

    const handleSaveProfileImage = async (data: Image64Data) => {
        await context.Journal.saveProfileImage(id, journalEntry.storage.versionTag, data);
    }
    
    const coverImageUri = "/images/demo/sunrise-sunset-facts.jpg";
    const displayName = `${journalEntry?.title}`;
    const initials = `${journalEntry?.title[0]} ${journalEntry?.title[1]}`;

    if (id === "new") {
        return <AddNewJournalEntryView/>
    }

    return (
        <div className="grid grid-flow-row auto-rows-max overflow-x-hidden">
            <div>
                <ImageCaptureDialog aspectRatio={1}
                                    isOpen={showImageCapture}
                                    onSave={handleSaveProfileImage}
                                    onClose={() => setShowImageCapture(false)}/>

                <nav className="flex items-start px-4 py-3 sm:px-6 lg:px-8 xl:hidden" aria-label="Breadcrumb">
                    <button onClick={backToList} className="inline-flex items-center space-x-3 text-sm font-medium text-gray-900">
                        <ChevronLeftIcon className="-ml-2 h-5 w-5 text-gray-400" aria-hidden="true"/>
                        <span>Journals</span>
                    </button>
                </nav>

                <div>
                    <div>
                        <img className="h-32 w-full object-cover lg:h-48" src={coverImageUri} alt=""/>
                    </div>
                    <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
                        <div className="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5">
                            <JournalEntryAvatar onClick={handleUpdateProfileImage} id={id} initials={initials} className="size-24 lg:size-36"/>
                            <div className="mt-6 sm:flex sm:min-w-0 sm:flex-1 sm:items-center sm:justify-end sm:space-x-6 sm:pb-1">
                                <div className="mt-6 min-w-0 flex-1 sm:hidden 2xl:block">
                                    <h1 className="truncate text-2xl font-bold text-gray-900">{truncateText(displayName)}</h1>
                                </div>
                                <div className="mt-6 flex flex-col justify-stretch space-y-3 sm:flex-row sm:space-x-4 sm:space-y-0">
                                    {/*<Button*/}
                                    {/*    type="button"*/}
                                    {/*    onClick={tagForFollowup}*/}
                                    {/*    className="inline-flex justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">*/}
                                    {/*    <CalendarDaysIcon className="-ml-0.5 h-5 w-5 text-gray-400" aria-hidden="true"/>*/}
                                    {/*    Tag for followup*/}
                                    {/*</Button>*/}
                                    {/*{journalEntry?.phone && <Button*/}
                                    {/*    type="button"*/}
                                    {/*    outline={true}*/}
                                    {/*    href={journalEntry?.phone ? `tel:${journalEntry?.phone}` : ''}*/}
                                    {/*    className="inline-flex justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">*/}
                                    {/*    <PhoneIcon className="-ml-0.5 h-5 w-5 text-gray-400" aria-hidden="true"/>*/}
                                    {/*    Call*/}
                                    {/*</Button>}*/}
                                </div>
                            </div>
                        </div>
                        <div className="mt-6 hidden min-w-0 flex-1 sm:block 2xl:hidden">
                            <h1 className="truncate text-2xl font-bold text-gray-900">{displayName}</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-6 sm:mt-2 2xl:mt-5 w-full overflow-x-scroll">
                <div className="flex border-b border-gray-200 w-full">
                    {/*<div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">*/}
                    <nav className="-mb-px flex space-x-4 whitespace-nowrap pr-4" aria-label="Tabs">
                        <Tab icon={QueueListIcon} name="Details" to="overview"/>
                    </nav>
                    {/*</div>*/}
                </div>
            </div>
            <div className="flex-1 flex-grow">
                <div className="flex h-full mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 overflow-y-auto">
                    <Outlet/>
                </div>
            </div>
        </div>
    )
}